/** Il menu laterale e la barra in alto della console (spostati qui il 27/10/2026). Gemello di `en.ts`. */
export default {
  barra: {
    titolo: 'Operator Console',
    piattaforma: 'PLATFORM',
    apri_menu: 'Apri il menu',
    stringi: 'Stringi il menu',
    allarga: 'Allarga il menu',
    stringi_tasti: 'Stringi il menu ({{tasti}})',
    allarga_tasti: 'Allarga il menu ({{tasti}})',
  },
  sezioni: {
    piattaforma: 'Piattaforma',
    acquisizione: 'Acquisizione',
    personale: 'Personale',
    assistenza: 'Assistenza',
  },
  voci: {
    tenants: 'Tenants',
    catalogo: 'Catalogo',
    anagrafe: 'Anagrafe',
    pricing: 'Pricing',
    consumi: 'Consumi',
    consegne: 'Da consegnare',
    motori_ai: 'Motori AI',
    permessi: 'Permessi edilizi',
    fornitori: 'Fornitori',
    listini_fornitori: 'Listini dei fornitori',
    app_mobile: 'App mobile',
    realta_aumentata: 'Realtà aumentata',
    documentazione: 'Documentazione',
    audit: 'Audit log',
    aziende: 'Aziende',
    questionari: 'Questionari',
    yuma_sito: 'Yuma sul sito',
    prove: 'Prove',
    partner: 'Partner',
    rete: 'Rete contatti',
    ticket: 'Ticket',
  },
  piede: {
    esci: 'Esci',
    versione: 'Console v1.0',
  },
} as const;
